<script setup>
import { useModalogStore } from "@/stores/modalog";
import BrandConfirmModalog from "@/Components/Modalogs/BrandConfirmModalog.vue";

const modalogStore = useModalogStore();

const openDeleteAccountConfirmation = () => {
    modalogStore.showModalog({
        type: "modalog-delete-account-confirmation",
        isConfirmDisabled: false,
    });
};
</script>

<template>
    <BrandConfirmModalog
        title="Delete Account"
        confirm-label="Confirm Account Deletion"
        danger
        @confirm="openDeleteAccountConfirmation"
    >
        <h3 class="text-[17px] font-bold text-brand-navy">
            Before you go&hellip;
        </h3>
        <p class="mt-2">
            At Gift Hero our number one priority is making gift giving easy for
            you. If you're unhappy with any part of the service we welcome your
            feedback to help us improve. Please email us at
            <a
                href="mailto:support@gifthero.com"
                class="font-semibold text-brand-navy underline underline-offset-2 transition hover:text-brand-red"
                >support@gifthero.com</a
            >.
        </p>
        <p class="mt-4 text-[16px] font-bold text-brand-navy">
            Deleting your Gift Hero account is permanent. If you proceed we
            cannot recover your account for you.
        </p>
        <p class="mt-4">
            When you delete your account you will no longer be able to log in
            and we will remove any connections to social accounts that you may
            have added. Any gifts that you have confirmed for other users will
            remain confirmed but your name will not be displayed.
        </p>
        <p class="mt-4">
            <button
                type="button"
                class="font-bold text-brand-navy underline underline-offset-2 transition hover:text-brand-red"
                @click="modalogStore.closeModalog()"
            >
                Never mind, I want to keep my account
            </button>
        </p>
    </BrandConfirmModalog>
</template>
